import { passengerTypeAction } from "../../../Actions/Index";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

export class OpenClosePassengerDropdownAction extends BaseAction<void, boolean> {

    override async run(): Promise<void | null> {
        try {
            updateRecoilState("isPassengerDropdownOpenAtom", !this.params);
            if (passengerTypeAction.result == null) {
                await passengerTypeAction.execute();
                updateRecoilState("passengerTypesStateAtom", passengerTypeAction.result);
            }
        } catch (error) {
            console.error("Error in OpenClosePassengerDropdownAction:", error);
        }
    }
}

// Create a singleton instance
export const openClosePassengerDropdownAction = new OpenClosePassengerDropdownAction(); 